var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon pin off",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h42v42H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m15.8 39.305.007-.01 6.086-9.074A15.731 15.731 0 0 0 15.8-.063a15.733 15.733 0 0 0-6.1 30.284l6.1 9.084m0-31.5a7.872 7.872 0 1 1-7.93 7.877 7.908 7.908 0 0 1 7.93-7.873M15.8 41l-.8-1.186-5.936-8.84A16.668 16.668 0 0 1 15.8-1a16.667 16.667 0 0 1 6.722 31.974zm0-32.253a6.935 6.935 0 1 0 6.983 6.935A6.967 6.967 0 0 0 15.8 8.747z",
    transform: "translate(5 1)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinOff);
export default __webpack_public_path__ + "static/media/pin-off.9021dc9468d829e17e5f9588989d3754.svg";
export { ForwardRef as ReactComponent };